import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "../../context/LangContext";
import { SERVICES } from "../../lib/data";
import { ProcessIcon } from "../icons/ProcessIcons";
import { Reveal, Tag } from "./Reveal";
import { MPattern } from "./MPattern";

const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

export const Services = () => {
  const { t, lang } = useLang();
  return (
    <section id="services" className="relative bg-brand-steel py-24 md:py-32 overflow-hidden" data-testid="services">
      <MPattern opacity={0.04} />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <Reveal>
          <Tag dark>{t.services.tag}</Tag>
          <h2 className="mt-5 font-display font-semibold text-white text-4xl sm:text-5xl lg:text-6xl max-w-3xl leading-[1.02]">
            {t.services.title}
          </h2>
          <p className="mt-6 max-w-2xl text-slate-400 text-base md:text-lg leading-relaxed">{t.services.subtitle}</p>
        </Reveal>

        <div className="mt-16 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {SERVICES.map((s, i) => (
            <Reveal key={s.id} delay={(i % 3) * 0.1}>
              <motion.div
                whileHover={{ y: -8 }}
                transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
                className="group relative h-full rounded-2xl border border-white/10 bg-gradient-to-b from-white/[0.06] to-transparent p-8 overflow-hidden"
                data-testid={`service-card-${s.id}`}
              >
                <div className="absolute -right-10 -top-10 h-40 w-40 rounded-full bg-brand-blue/10 blur-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-700" />
                <div className="relative flex items-start justify-between">
                  <div className="h-16 w-16 rounded-full bg-[#E0F2FE] flex items-center justify-center text-brand-blue p-4">
                    <ProcessIcon name={s.icon} className="block h-full w-full" />
                  </div>
                  <span className="font-display text-sm text-white/20 font-semibold">0{i + 1}</span>
                </div>
                <h3 className="relative mt-8 font-display text-2xl font-medium text-white">{s[lang].name}</h3>
                <p className="relative mt-3 text-sm text-slate-400 leading-relaxed">{s[lang].desc}</p>
                <button
                  onClick={() => scrollTo("contact")}
                  className="relative mt-6 inline-flex items-center gap-1.5 font-condensed text-xs uppercase tracking-[0.2em] text-brand-azure hover:text-white transition-colors"
                  data-testid={`service-cta-${s.id}`}
                >
                  {t.nav.quote} <ArrowUpRight size={14} />
                </button>
              </motion.div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
